// extracted by mini-css-extract-plugin
export default {"currentRow":"RuleHistoryTable_currentRow__HGuuN"};